import { reducerRegistry } from '../../../../reducerRegistry';
import formsReducersMap from './forms/reducersMap';

const combineMap = {
  forms: formsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('feedbackModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/reducers/static/combineRegistry.js